import type { Avsnitt as AvsnittTyp } from '../types'
import MarkeradText from './MarkeradText'
import Illustration from './Illustration'
import Tabell from './Tabell'
import Ruta from './Ruta'

/** Ett kapitelavsnitt: rubrik, brödtext och de figurer som knutits till
 *  avsnittet via kapitel.json (placering "fore"/"efter" avsnittstexten).
 *  `medAnkare` sätter avsnittets id (mål för teorisektionens Läs mer-länkar) —
 *  bara på kapitelsidan, inte i hela läromedlet-utskriften där samma
 *  avsnittsrubrik i olika kapitel skulle ge id-dubbletter.
 *
 *  Tabeller och rutor renderas SIST, efter brödtext och "efter"-illustrationer:
 *  källans schema ger dem ingen egen plats i brödtexten (inget ankare, ingen
 *  inline-markör) — de är enligt sin egen beskrivning sådant eleven kan slå
 *  upp vid behov, inte sådant som krävs för att förstå löptexten. */
export default function Avsnitt({ avsnitt, medAnkare = false }: { avsnitt: AvsnittTyp; medAnkare?: boolean }) {
  const fore = avsnitt.illustrationer.filter((i) => i.placering === 'fore')
  const efter = avsnitt.illustrationer.filter((i) => i.placering !== 'fore')

  return (
    <section>
      <h2 id={medAnkare ? avsnitt.ankare : undefined}>{avsnitt.rubrik}</h2>
      {fore.map((ill) => (
        <Illustration key={ill.fil} src={ill.fil} alt={ill.alt} bildtext={ill.bildtext} />
      ))}
      <MarkeradText markdown={avsnitt.markdown} />
      {efter.map((ill) => (
        <Illustration key={ill.fil} src={ill.fil} alt={ill.alt} bildtext={ill.bildtext} />
      ))}
      {avsnitt.tabeller.map((tabell) => (
        <Tabell key={tabell.rubrik} tabell={tabell} />
      ))}
      {avsnitt.rutor.map((ruta) => (
        <Ruta key={ruta.rubrik} ruta={ruta} />
      ))}
    </section>
  )
}
